module.exports = __webpack_public_path__ + "static/media/87.2fe7d7cc.jpg";